import { PrimaryButton } from "elements";
import styled from "styled-components";

export const SocialLoginButton = styled(PrimaryButton)`
    min-width: 356px;
    >.ant-btn-icon {
        position: absolute;
        left: 20px;
    }
`
